import { Vue, Component, Prop } from 'vue-property-decorator';
import Datum from '@/interfaces/Datum';
import { eventBus } from '@/utils/EventBus';

@Component({})
export default class RightClickMenu extends Vue {
  // 선택된 노드
  private clickedNode!: d3.HierarchyPointNode<Datum>;
  // 메뉴가 보이느냐 안보이느냐
  private isShown: boolean = false;
  /**
   * 메뉴의 좌표
   */
  private leftPosition: number = 0;
  private topPosition: number = 0;

  /**
   * 버튼의 유무
   */
  private canUnselect: boolean = false;
  private canSplit: boolean = false;
  private canFold: boolean = false;
  private canUnfold: boolean = false;

  /**
   * 오른쪽 메뉴를 여는 함수
   * @param o.x x좌표
   * @param o.y y좌표
   * @param o.clickedNode 클릭한 노드
   * @param o.canUnselect 선택 취소가 가능한가
   * @param o.canSplit split이 가능한가
   * @param o.canFold fold(접기)가 가능한가
   * @param o.canUnfold unfold(펼치기)가 가능한가
   */
  public open(o: {
    x: number,
    y: number,
    clickedNode: d3.HierarchyPointNode<Datum>,
    canUnselect: boolean,
    canSplit: boolean,
    canFold: boolean,
    canUnfold: boolean
  }) {
    this.leftPosition = o.x;
    this.topPosition = o.y;
    this.clickedNode = o.clickedNode;

    this.canUnselect = o.canUnselect;
    this.canSplit = o.canSplit;
    this.canFold = o.canFold;
    this.canUnfold = o.canUnfold;

    this.isShown = true;
  }

  /**
   * 오른쪽 메뉴를 닫는 함수
   */
  public close() {
    this.isShown = false;
  }

  private unselectComponent() {
    eventBus.$emit('componentNodeUnselected', this.clickedNode);
  }

  private split() {
    // @ts-ignore
    this.$parent.applySplit(this.clickedNode);
  }

  private async foldNode() {
    // @ts-ignore
    this.$parent.foldNode(this.clickedNode);
    // @ts-ignore
    this.$parent.updateLayout(); // Because the collapse is updated, re-layout.
    // @ts-ignore
    await this.$parent.draw(250, this.clickedNode); // draw
    // @ts-ignore
    this.$parent.updateViewBox();
  }

  private async unfoldNode() {
    // @ts-ignore
    this.$parent.unfoldNode(this.clickedNode);
    // @ts-ignore
    this.$parent.updateLayout(); // Because the collapse is updated, re-layout.
    // @ts-ignore
    await this.$parent.draw(250, this.clickedNode); // draw
    // @ts-ignore
    this.$parent.updateViewBox();
  }


  private mounted() {
    //
  }

  private get menuContainerStyle() {
    return {
      position: 'fixed',
      left: `${this.leftPosition}px`,
      top: `${this.topPosition}px`
    };
  }
}
